import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { Menu, MenuItem, Box, Button } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import CheckIcon from '@material-ui/icons/Check';
// import Link from '@rcg/ui-react';
import useStyles from './index.style';

const Drop = ({
  className = '',
  menuItems,
  id = 'MuiMenu',
  icon = <KeyboardArrowDownIcon />,
  selectedIcon = <CheckIcon />,
  onSelectedOption = () => {},
  disabled = false,
  setSelectedOption = null,
  ...others
}) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selected, setSelected] = useState(menuItems[0].name);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    event.preventDefault();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const chosenOption = (event) => {
    const { option } = event.currentTarget.dataset;
    const selectedFoundOption = menuItems.find(
      (selectedOoption) => selectedOoption.name === option,
    );
    const { key } = selectedFoundOption;
    setSelected(option);
    onSelectedOption({ option, id, key });
    setAnchorEl(null);
  };

  useEffect(() => {
    if (!setSelectedOption) {
      setSelected(menuItems[0].name);
    } else {
      setSelected(setSelectedOption.name);
    }
  }, [setSelectedOption, menuItems]);

  return (
    <div key={id} {...others} className={clsx(classes.root, className)}>
      <Box>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <Button
          data-testid="search-menu"
          component="a"
          underline="none"
          disabled={disabled}
          aria-controls={id}
          aria-haspopup="true"
          className={`${classes.label}`}
          onClick={handleClick}>
          {selected || menuItems[0].name}
          {!disabled && icon}
        </Button>
      </Box>
      <Menu
        className={`${classes.rootMenu}`}
        data-testid={`menu-${id}`}
        id={id}
        anchorEl={anchorEl}
        keepMounted
        MenuListProps={{ 'data-testid': 'menulist' }}
        open={Boolean(anchorEl)}
        onClose={handleClose}>
        {menuItems &&
          menuItems.map((option, i) => {
            return (
              <MenuItem
                data-testid={`menu-option${i}`}
                // eslint-disable-next-line react/no-array-index-key
                key={`${option.key}-${i}`}
                selected={option.name === selected}
                data-option={option.name}
                onClick={(event) => chosenOption(event)}
                disableTouchRipple>
                {option.name === selected ? selectedIcon : null}
                <Box className="menuList">{option.name}</Box>
              </MenuItem>
            );
          })}
      </Menu>
    </div>
  );
};

export default Drop;
